import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import { TableauTokenData } from '../types/TableauTokenData';


export const useGetTableauTokenData = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['get-tableau-token-data'],
        queryFn: async () => await apiClient.get('/metrics/get-tableau-token-data') as TableauTokenData
    });

    return {
        data: data || { server: '', token: '-1' } as TableauTokenData,
        isLoading: isLoading
    };
};
